<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row>
    <DeleteProduct v-model="showDeleteProductDialog" />
    <NewEditProduct />

    <!-- UploadProductImagen: -->
    <UploadProductImagen
      :showUploadImageDialog="showSetProductPhoto"
      :loadingUploadImage="uploadingProductPhoto"
      :mainLabel="$t('general.photos')"
      :secondaryLabel="$t('general.thePictures')"
      formFileFieldName="product-photo"
      methodToDispatchUpload="uploadProductPhoto"
      @toggleShowUploadImageDialog="
        (value) => {
          showSetProductPhoto = value
        }
      "
    />

    <!-- UploadProductMiniatureImagen: -->
    <UploadProductImagen
      :showUploadImageDialog="showSetProductMiniaturePhoto"
      :loadingUploadImage="uploadingProductPhoto"
      :mainLabel="$t('general.miniaturePhotos')"
      :secondaryLabel="$t('general.theMiniatures')"
      formFileFieldName="product-miniature-photo"
      methodToDispatchUpload="uploadProductMiniaturePhoto"
      @toggleShowUploadImageDialog="
        (value) => {
          showSetProductMiniaturePhoto = value
        }
      "
    />
    <v-col cols="12" sm="6">
      <v-select
        :label="$t('general.place')"
        color="kbDarkBlue"
        :items="places"
        item-text="name"
        item-value="id"
        @change="getProducts()"
        v-model="selectedPlaceId"
      >
        <template v-slot:append-outer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="kbDarkBlue"
                @click="clearPlaceSelection"
                class="ml-2"
              >
                mdi-close
              </v-icon>
            </template>
            <span>Clear</span>
          </v-tooltip>
        </template>
      </v-select>
    </v-col>

    <v-col cols="12" sm="6">
      <v-select
        :label="$t('general.productsCategories')"
        color="kbDarkBlue"
        :items="productsCategories"
        item-text="name"
        item-value="_id"
        @change="getProducts()"
        v-model="selectedProductsCategoryId"
      >
        <template v-slot:append-outer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                color="kbDarkBlue"
                @click="clearProductsCategorySelection"
                class="ml-2"
              >
                mdi-close
              </v-icon>
            </template>
            <span>Clear</span>
          </v-tooltip>
        </template>
      </v-select>
    </v-col>

    <v-col cols="12" class="d-flex justify-space-between align-center">
      <v-text-field
        :hint="$t('general.search')"
        clearable
        class="mr-3"
        color="kbDarkBlue"
        :placeholder="$t('general.search')"
        v-model="search"
      ></v-text-field>
      <v-tooltip :disabled="companyBlocked" bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-btn
              :disabled="companyBlocked"
              dark
              @click="showCreateProduct"
              color="kbPurple"
            >
              {{ $t('general.createProduct') }}
            </v-btn>
          </div>
        </template>
        <span>
          {{
            companyBlocked
              ? $t('general.mustChargeBeforeCreatingProducts')
              : $t('general.createProduct')
          }}
        </span>
      </v-tooltip>
    </v-col>

    <v-col class="text-h6" cols="12">
      <v-data-table
        class="elevation-2"
        :headers="headers"
        :items="products"
        :loading="loadingProducts"
        :options.sync="optionsProducts"
        :footer-props="{
          'items-per-page-text': `${$t('general.products')} ${$t(
            'general.perPage',
          )}`,
          'items-per-page-options': [50, 100, 200],
        }"
        :server-items-length="totalProducts"
      >
        <template v-slot:item="{ item }">
          <tr>
            <td class="font-weight-bold text-capitalize">
              {{ item.name || $t('general.noName') }}
            </td>
            <td class="font-weight-bold text-capitalize">{{ item.sku }}</td>
            <td class="font-weight-bold text-capitalize">
              {{ item.description }}
            </td>
            <td class="font-weight-bold text-capitalize">{{ item.price }}</td>
            <td class="font-weight-bold text-capitalize">
              {{ item.discountPrice }}
            </td>
            <td class="font-weight-bold text-capitalize">{{ item.stock }}</td>
            <td>
              <v-switch
                hide-details
                disabled
                color="kbDarkBlue"
                class="mt-0"
                v-model="item.active"
              />
            </td>

            <td>{{ convertTZToUserTZ(item.createdAt) | moment('DD/MM/YYYY hh:mma') }}</td>
            <td class="ma-0 pa-0">
              <div
                class="data-table-actions d-flex justify-center align-center"
              >
                <v-btn @click="showProduct(item)" color="kbDarkBlue" text icon>
                  <v-icon>remove_red_eye</v-icon>
                </v-btn>

                <v-menu>
                  <template v-slot:activator="{ on }">
                    <v-btn color="kbDarkBlue" text icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item @click="showEditProduct(item)">
                      <v-list-item-action>
                        <v-icon color="kbDarkBlue">edit</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>
                        {{ $t('general.editProduct') }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="showDialogSetPhoto(item)">
                      <v-list-item-action>
                        <v-icon color="kbDarkBlue">account_box</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>
                        {{ $t('general.setProductPhoto') }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="showDialogSetMiniaturePhoto(item)">
                      <v-list-item-action>
                        <v-icon color="kbDarkBlue">account_box</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>
                        {{ $t('general.setProductMiniaturePhoto') }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item @click="showDeleteProduct(item)">
                      <v-list-item-action>
                        <v-icon color="kbDarkBlue">delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>
                        {{ $t('general.deleteProduct') }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </td>
          </tr>
        </template>

        <template v-slot:no-data>
          <v-row>
            <v-col class="text-center" v-if="loadingProducts" cols="12">
              {{ $t('general.loadingProducts') }}
            </v-col>
            <v-col class="red--text text-center" v-else cols="12">
              {{ $t('general.noProductsRegistered') }}
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import DeleteProduct from '@/pages/App/Events/dialogs/DeleteProduct'
import NewEditProduct from '@/pages/App/Events/dialogs/NewEditProduct'
import TimeZones from '@/mixins/TimeZones'
import UploadProductImagen from '@/pages/App/Events/dialogs/UploadProductImagen'

export default {
  components: {
    DeleteProduct,
    NewEditProduct,
    UploadProductImagen
  },
  computed: {
    ...mapState({
      selectedApp: (state) => state.apps.selectedApp,
      products: (state) => state.events.products,
      totalProducts: (state) => state.events.totalProducts,
      loadingProducts: (state) => state.events.loadingProducts,
      uploadingProductPhoto: (state) => state.events.uploadingProductPhoto,
      uploadingProductBannerPhoto: (state) =>
        state.events.uploadingProductBannerPhoto,
      places: (state) => state.events.places,
      productsCategories: (state) => state.events.productsCategories
    }),
    ...mapGetters(['companyBlocked']),
    search: {
      get () {
        return this.$store.state.events.searchProducts
      },
      set (value) {
        this.$store.commit('SET_SEARCH_PRODUCTS', value)
      }
    },
    isSearching () {
      return this.search && this.search !== ''
    },
    optionsProducts: {
      get () {
        return this.$store.state.events.optionsProducts
      },
      set (value) {
        this.$store.commit('SET_PAGINATION_PRODUCTS', value)
      }
    },
    showNewEditProductDialog: {
      get () {
        return this.$store.state.events.showNewEditProductDialog
      },
      set (value) {
        this.$store.commit('SET_SHOW_NEW_EDIT_PRODUCT_DIALOG', value)
      }
    },
    showSetProductPhoto: {
      get () {
        return this.$store.state.events.showSetProductPhoto
      },
      set (value) {
        this.$store.commit('SET_SHOW_SET_PRODUCT_PHOTO', value)
      }
    },
    showSetProductMiniaturePhoto: {
      get () {
        return this.$store.state.events.showSetProductMiniaturePhoto
      },
      set (value) {
        this.$store.commit('SET_SHOW_SET_PRODUCT_MINIATURE_PHOTO', value)
      }
    },
    headers () {
      return [
        { text: this.$t('general.name'), value: 'name' },
        { text: 'sku', value: 'sku' },
        { text: this.$t('general.description'), value: 'description' },
        { text: this.$t('general.price'), value: 'price' },
        { text: this.$t('general.discountPrice'), value: 'discountPrice' },
        { text: this.$t('general.stock'), value: 'stock' },
        { text: this.$t('general.active'), value: 'active' },
        { text: this.$t('general.creationDate'), value: 'createdAt' },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false,
          value: ''
        }
      ]
    }
  },
  created () {
    this.$store.dispatch('getProductsCategories')
    this.getPlaces()
  },
  data () {
    return {
      showDeleteProductDialog: false,
      selectedPlaceId: '',
      selectedProductsCategoryId: ''
    }
  },
  methods: {
    showCreateProduct () {
      this.$store.commit('SET_METHOD_CREATE_OR_UPDATE_PRODUCT', 'new')
      this.showNewEditProductDialog = true
    },
    clearPlaceSelection () {
      this.selectedPlaceId = ''
      this.getProducts()
    },
    clearProductsCategorySelection () {
      this.selectedProductsCategoryId = ''
      this.getProducts()
    },
    getProducts () {
      this.$store.dispatch('getProducts', {
        placeId: this.selectedPlaceId, productsCategoryId: this.selectedProductsCategoryId
      })
    },
    getPlaces () {
      this.$store.dispatch('getPlaces')
    },
    showProduct (product) {
      this.$store.commit('SET_METHOD_CREATE_OR_UPDATE_PRODUCT', 'view')
      this.$store.commit('SET_NEW_EDIT_PRODUCT_OBJ', { ...product })
      this.showNewEditProductDialog = true
    },
    showDialogSetPhoto (product) {
      this.$store.commit('SET_SELECTED_PRODUCT', product)
      this.$store.commit('SET_SHOW_SET_PRODUCT_PHOTO', true)
    },
    showDialogSetMiniaturePhoto (product) {
      this.$store.commit('SET_SELECTED_PRODUCT', product)
      this.showSetProductMiniaturePhoto = true
    },
    showEditProduct (product) {
      this.$store.commit('SET_METHOD_CREATE_OR_UPDATE_PRODUCT', 'edit')
      this.$store.commit('SET_NEW_EDIT_PRODUCT_OBJ', { ...product })
      this.showNewEditProductDialog = true
    },
    showDeleteProduct (product) {
      this.$store.commit('SET_SELECTED_PRODUCT', product)
      this.showDeleteProductDialog = true
    }
  },
  mixins: [TimeZones],
  watch: {
    optionsProducts: {
      handler () {
        this.getProducts()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    search () {
      this.optionsProducts.page = 1
      this.getProducts()
    },
    selectedApp () {
      this.getProducts()
      this.getPlaces()
    }
  }
}
</script>
